import { IServiceList } from "@command-center-app/index";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface VendorServiceState {
  services: IServiceList[];
  loading: boolean;
  error: string | null;
  selectedService: IServiceList | null;
  serviceId: string | null;
}

const initialState: VendorServiceState = {
  services: [],
  loading: false,
  error: null,
  selectedService: null,
  serviceId: null,
};

const vendorServicesSlice = createSlice({
  name: "vendorServices",
  initialState,
  reducers: {
    fetchVendorServicesRequest(state:any) {
      state.loading = true;
      state.error = null;
    },
    fetchVendorServicesSuccess(state:any, action: PayloadAction<IServiceList[]>) {
      state.loading = false;
      state.services = action.payload;
    },
    fetchVendorServicesFailed(state:any, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    setSelectedOffering(state:any, action: PayloadAction<IServiceList | null>) {
      state.selectedService = action.payload;
    },
    setServiceId(state: any, action: PayloadAction<string | null>) { 
      state.serviceId = action.payload;
    }
  },
});

export const {
  fetchVendorServicesRequest,
  fetchVendorServicesSuccess,
  fetchVendorServicesFailed,
  setSelectedOffering,
  setServiceId
} = vendorServicesSlice.actions;

export default vendorServicesSlice.reducer;
